<template>
  <v-page no-padding :white="!isFeedThread">
    <div
      :class="[
        {
          '--comments': isCommentThread,
          '--feed': isFeedThread,
          'bg-white': !isFeedThread,
          'h-full': !isCommentThread
        },
        'message-thread__page'
      ]"
    >
      <template v-if="isLoading || !hasCheckedAuthentication">
        <div
          class="w-100 h-full d-flex align-items-center justify-content-center"
        >
          <v-loader />
        </div>
      </template>
      <template v-else-if="messageThreadId">
        <thread-header :message-thread="messageThread" />

        <message-thread
          :with-reactions="showReactions"
          :message-thread-id="messageThreadId"
          :is-comment-thread="isCommentThread"
          :placeholder="
            isCommentThread ? 'Write a reply...' : 'Write something...'
          "
        />
      </template>
    </div>
  </v-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import MessageThread from "@/components/message-thread/Thread"
import ThreadHeader from "@/components/message-thread/Header"

export default {
  name: "MessageThreadShow",

  components: {
    MessageThread,
    ThreadHeader
  },

  data() {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapGetters("messages", ["getMessageThread"]),
    ...mapGetters("auth", ["isAuthenticated", "hasCheckedAuthentication"]),

    showReactions() {
      return !!this.$route.query.reactions
    },

    messageThreadId() {
      return this.$route.params.id
    },

    messageThread() {
      return this.getMessageThread(this.messageThreadId)
    },

    isCommentThread() {
      return this.messageThread && !!this.messageThread.parent_message
    },

    isFeedThread() {
      return this.messageThread?.parent_message?.message_thread?.is_feed
    }
  },

  watch: {
    hasCheckedAuthentication: {
      immediate: true,
      handler: function() {
        if (
          this.hasCheckedAuthentication &&
          this.isAuthenticated &&
          !this.messageThread
        ) {
          this.isLoading = true
          this.fetchMessageThread(this.messageThreadId)
            .catch(err => {
              if (err.response.status === 430) {
                this.$router.replace("/")
              }
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      }
    }
  },

  methods: {
    ...mapActions("messages", ["fetchMessageThread"])
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.message-thread__page {
  background: $color-ui--background;

  &.--feed {
    background: $color-ui--grey-10;
    min-height: 100vh;

    .message-thread {
      margin-top: -1px;
      border: 1px solid $color-ui--grey-20;
      background: $color-ui--white;
      border-bottom-left-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);
    }
  }

  .message-thread {
    height: var(--app-height);
    height: calc(
      var(--app-height) - #{$thread--header-height} - env(safe-area-inset-bottom)
    );
  }

  &.--comments {
    .message-thread {
      height: auto;
      min-height: auto;
    }

    .message-thread__content-wrapper {
      overflow: initial;
    }
  }
}
</style>
